export default __webpack_public_path__ + "assets/icons/freightArrow.32791e91.svg";